import { Box, Flex, Text } from '@chakra-ui/react'
import _ from 'lodash'

import AlertCard, { alertRiskLevelOrder } from 'modules/Alerts'

import { AlertsType } from 'api/cms/alerts/useCountryAlerts'

import { formatDate } from 'utils/formatDate'

const customAlertsSort = (a: AlertsType, b: AlertsType) =>
  alertRiskLevelOrder.indexOf(a.type) - alertRiskLevelOrder.indexOf(b.type)

export const sortAlerts = (alerts: AlertsType[]) =>
  alerts?.sort(customAlertsSort)
const Alert = ({
  index,
  displayDates,
  groupedAlerts,
  fullPage,
}: {
  index: number
  displayDates: string[]
  groupedAlerts: _.Dictionary<AlertsType[]>
  fullPage?: boolean
}) => {
  const date = displayDates[index]
  const dayAlerts = groupedAlerts[date]
  const dayIndex = index
  return (
    <>
      <Box mb='3'>
        <Box w='fit-content'>
          <Text fontSize='sm' color='legacy-primary.400'>
            {formatDate(new Date(date))} ({dayAlerts?.length})
          </Text>
          <Box h='1px' bg='legacy-primary.200' mb='2' mr='-1rem' />
        </Box>
        {sortAlerts(dayAlerts)?.map((alert, index) => {
          return (
            <AlertCard
              key={index}
              alert={alert}
              fullPage={fullPage}
              forceOpen={fullPage && dayIndex === 0}
            />
          )
        })}
      </Box>
    </>
  )
}
export const GroupedAlerts = ({
  alerts,
  alertsPerDay,
}: {
  alerts: any[]
  alertsPerDay: Record<string, number> | undefined
}) => {
  let initialGroups = _.groupBy(alerts, (alert) => alert.datePublished)

  return (
    <>
      <Box mb='3'>
        {Object.keys(initialGroups)?.map((day, index) => {
          const alertsDay = initialGroups[day]
          return (
            <Flex key={day} flexDir={'column'}>
              <Box w='fit-content'>
                <Text fontSize='sm' color='legacy-primary.400'>
                  {formatDate(new Date(day))} ({alertsPerDay?.[day]})
                </Text>
                <Box h='1px' bg='legacy-primary.200' mb='2' mr='-1rem' />
              </Box>
              {alertsDay.map((alert, index) => {
                return (
                  <AlertCard
                    key={index}
                    alert={alert}
                    fullPage={false}
                    forceOpen={false}
                  />
                )
              })}
            </Flex>
          )
        })}
      </Box>
    </>
  )
}

export default Alert
